export default __webpack_public_path__ + "static/media/npc-logo.31f51236.png";